import ChangePasswordModal from './ChangePasswordModal';

export type { ChangePasswordModalProps } from './ChangePasswordModal';

export default ChangePasswordModal;
